import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Col } from "react-bootstrap";
import NonTruckList from "./NonTruckList";
import TruckList from "./TruckList";
import SeedTruckList from "./SeedTruckList";

const Body = (props) => {
  const selectedPlanType = useSelector((state) => state.plan.selectedPlanType);
  const isAllPlan = useSelector((state) => state.plan.isSelectAllPlan);
  // const plan_type_id = useSelector(state => state.user.userSettings.plan_type_id);
  const {
      selectedWorkTypeIds: activeWorkType,
    } = useSelector((state) => state.dashboard.leaderBoard);

  const showTruckList = useMemo(() => {
    if ([4, 2].includes(selectedPlanType) || isAllPlan /* && activeWorkType.includes(1) */) return true;
    return false;
  }, [selectedPlanType, activeWorkType]);

  return (
    <>
      <Col className="body">
        {activeWorkType.includes(6) ? <SeedTruckList /> : <NonTruckList />}
        {showTruckList && <TruckList />}
      </Col>
    </>
  );
};

export default Body;
